export const TRANSITION_SETTING = {
  duration: 0.2,
  ease: [0.43, 0.13, 0.23, 0.96],
};

export const ROUTE_VARIANTS = {
  exit: {
    opacity: 0,
    transition: TRANSITION_SETTING,
  },
  enter: {
    opacity: 1,
    transition: TRANSITION_SETTING,
  },
};

export const ROUTE_CONTAINER_SETTINGS = {
  initial: 'exit',
  animate: 'enter',
  exit: 'exit',
};
